import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    // tslint:disable-next-line:component-selector
    selector: '[eas-editor-booking-item-bundle]',
    templateUrl: './editor-booking-item-bundle.component.html',
    styleUrls: ['./editor-booking-item-bundle.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemBundleComponent implements OnChanges, OnInit, OnDestroy {
  @Input() item: EditorBookingItem;

  private destroyed$ = new Subject<void>();

  bookingItemNames: { id: string, name: string }[];

  summary: string;

  constructor(
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore,
    private editorData: EditorDataService
  ) {

  }

  ngOnInit() {
    this.editorData.bookingItemNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingItemNames => {
        this.bookingItemNames = bookingItemNames;
        this.updateSummary();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.item) {
      if (this.bookingItemNames !== undefined) {
        this.updateSummary();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  updateSummary() {
    this.summary = this.item.bundle
      .map(
        bundleItemId =>
          this.bookingItemNames.find(bookingItemName => bookingItemName.id === bundleItemId).name
      )
      .join(', ');
  }

  onEdit() {
    this.itemEditStore.startEditing(this.item.id, { name: 'bundle', value: null });
    this.itemDialogStore.editBookingItem();
    return false;
  }

  get cssClassName(): string {
    return this.item.bundle.length > 0 ? 'option_row--set' : 'option_row--empty';
  }
}
